<template>
  <div class="kits-accessories-page">
    <!-- Banner Section -->
    <section class="banner-section">
      <div class="banner-content">
        <h1 class="banner-title">{{ bannerTitle }}</h1>
      </div>
    </section>

    <!-- Accessories List Section -->
    <section class="accessories-section">
      <div class="container">
        <div class="accessories-grid">
          <div class="accessory-item"
               v-for="(item, index) in accessories"
               :key="index">
            <div class="item-image-wrapper">
              <img :src="item.image"
                   :alt="item.name"
                   class="item-image">
            </div>
            <p class="item-name">{{ item.name }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'KitsAccessories',
  data() {
    return {
      accessoryAssets: [
        { image: require('@/assets/product/kits/kitac1.png') },
        { image: require('@/assets/product/kits/kitac2.png') },
        { image: require('@/assets/product/kits/kitac3.png') },
        { image: require('@/assets/product/kits/kitac4.png') },
        { image: require('@/assets/product/kits/kitac5.png') },
        { image: require('@/assets/product/kits/kitac6.png') },
        { image: require('@/assets/product/kits/kitac7.png') },
        { image: require('@/assets/product/kits/kitac8.png') },
        { image: require('@/assets/product/kits/kitac9.png') },
        { image: require('@/assets/product/kits/kitac10.png') },
        { image: require('@/assets/product/kits/kitac11.png') },
        { image: require('@/assets/product/kits/kitac12.png') },
        { image: require('@/assets/product/kits/kitac13.png') },
        { image: require('@/assets/product/kits/kitac14.png') },
        { image: require('@/assets/product/kits/kitac15.png') },
        { image: require('@/assets/product/kits/kitac16.png') },
        { image: require('@/assets/product/kits/kitac17.png') },
        { image: require('@/assets/product/kits/kitac18.png') },
        { image: require('@/assets/product/kits/kitac19.png') },
        { image: require('@/assets/product/kits/kitac20.png') }
      ],
    }
  },
  computed: {
    productKitsAccessoriesCopy() {
      const locale = this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'zh-CN'
      const messages =
        this.$i18n && this.$i18n.getLocaleMessage
          ? this.$i18n.getLocaleMessage(locale)
          : {}
      return (messages.product && messages.product.kitsAccessories) || {}
    },
    bannerTitle() {
      return this.productKitsAccessoriesCopy.bannerTitle || ''
    },
    accessories() {
      const items = this.productKitsAccessoriesCopy.accessories || []
      return items.map((item, index) => {
        const asset = this.accessoryAssets[index] || {}
        return {
          name: item.name || '',
          image: asset.image || '',
        }
      })
    },
  },
}
</script>

<style scoped>
.kits-accessories-page {
  width: 100%;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

/* Banner Section */
.banner-section {
  width: 100%;
  height: 680px;
  background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
    url("@/assets/product/kits/kitsbanner.png");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-content {
  text-align: center;
}

.banner-title {
  font-size: 48px;
  font-weight: bold;
  color: #fff;
  margin: 0;
}

/* Accessories Section */
.accessories-section {
  width: 100%;
  min-height: 1419px; /* Initial height, adaptable */
  background-color: #f4f6fa;
  padding-top: 80px;
  padding-bottom: 80px;
  box-sizing: border-box;
}

.container {
  width: 1200px;
  margin: 0 auto;
}

.accessories-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 40px; /* Adjust gap to fit 5 items in 1200px (approx 240px per column space) */
  justify-items: center;
}

.accessory-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
}

.item-image-wrapper {
  width: 209px;
  height: 209px;
  border-radius: 50%;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.item-image {
  width: 140px; /* Adjust image size inside the circle */
  height: 140px;
  object-fit: contain;
}

.item-name {
  font-size: 20px;
  color: #333;
  margin: 0;
  text-align: center;
}
</style>
